import styled from 'styled-components';
import { BackgroundSignIn } from '../../Assets';

export const Container = styled.div`
    display: flex;
    align-items: stretch;
    height:100vh;
    place-content: center;
    width:100vw;
    h4 {
        color: #222e50;
    }
    a   { 

        color: #222e50;
        display: flex;
        font-size: 12px;
        align-items: center;
        place-content: center;
    }
    svg {
        margin-right: 10px;
    }
`;
export const Background = styled.div`
    flex: 1;
    background: url(${BackgroundSignIn}) no-repeat center;
    background-size: cover;
`;
export const Form = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    place-content: center;
    width: 300px;
    height:calc(100vh - 40px);
    overflow: auto;
    img {
        width: 70%;
    }
    a   {
        font-size: 12px;
        color: #000;
        padding-bottom: 10px;
    }
    svg {
        margin-right: 6px;
        color: #222e50;
    }
    h6 {
        padding-bottom: 8px;
    }

    button {
        margin-bottom: 50px;
        width: 190px;
        font-weight: 500;
    }
    img {
        width: 40%;
    }
`;
export const Footer = styled.div`
    @media (max-width:1250px) and (min-width:1150px) and (max-height:2050px) and (min-height:1950px) {

    }
    @media (max-width:2050px) and (min-width:1950px) and (max-height:1250px) and (min-height:1150px) {

    }
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    place-content: center;
`;